import Clarity from '@microsoft/clarity';
import { clarityProjectId, useClarity } from './configConstants';

export const initClarity = () => {
  if (useClarity) {
    Clarity.init(clarityProjectId);
  }
};

/** Marks the recording, so sessions where it happened can be found in Clarity. */
export const clarityEvent = (name: string) => {
  if (useClarity) {
    Clarity.event(name);
  }
};

export const setClarityUser = (userId: number) => {
  if (useClarity) {
    Clarity.identify(userId.toString());
  }
};
